import React from "react"

import SelectTags from "../../../common/tags/SelectTags"

const UserEditRelatedPanelWidget = ({
    permission_groups,
    topics_followed,
    communities_followed,
    communities_member_of,
    onTopicsSearch,
    onPermissionGroupsSearch,
    onCommunitiesSearch,
    onValueChange
}) => (
    <div className="widget">
        <div className="widget-content visible">
            <h3 className="first-heading">
                <i className="icon icon-insights" />Permission groups
            </h3>
            <SelectTags
                labelKey="id"
                name="permission_groups"
                value={permission_groups}
                placeholder="Add permission group"
                loadOptions={onPermissionGroupsSearch}
                onChange={onValueChange("permission_groups")}
            />
            <h3>
                <i className="icon icon-insights" />Insight areas followed
            </h3>
            <SelectTags
                name="topics_followed"
                value={topics_followed}
                placeholder="Add insight areas"
                loadOptions={onTopicsSearch}
                onChange={onValueChange("topics_followed")}
            />
            <h3>
                <i className="icon icon-insights" />Communities followed
            </h3>
            <SelectTags
                name="communities_followed"
                value={communities_followed}
                placeholder="Add community"
                loadOptions={onCommunitiesSearch}
                onChange={onValueChange("communities_followed")}
            />
            <h3>
                <i className="icon icon-community" />Member of
            </h3>
            <SelectTags
                name="communities_member_of"
                value={communities_member_of}
                placeholder="Add community"
                loadOptions={onCommunitiesSearch}
                onChange={onValueChange("communities_member_of")}
            />
        </div>
    </div>
)

export default UserEditRelatedPanelWidget
